import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaYoutube,
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import ralaLogo from "../../Assets/rala_infotech_color.svg";
import startupIndia from "../../Assets/StartupIndia.jpeg";
import iso9001 from "../../Assets/ISO9001.jpeg";
import iso14001 from "../../Assets/ISO14001.jpeg";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="portal-footer">
      <div className="portal-footer-container">
        <div className="portal-footer-main">
          <div className="portal-footer-offices">
            <div className="portal-footer-office-section">
              <img src={ralaLogo} alt="Rala Infotech" className="portal-footer-logo" />

              <div className="portal-office-card">
                <h5><FaMapMarkerAlt /> REGISTERED OFFICE</h5>
                <strong>Rala Infotech India Pvt. Ltd.</strong>
                <p>
                  Ashok Nagar, 3rd Cross, Medleri Road,Ranebennur, Haveri, Karnataka – 581115.
                  <br />
                  Landmark:  Near Vishal Mega Mart /
                  Om Hospital.
                </p>
              </div>
            </div>

            <div className="portal-footer-office-section">
              <img
                src={ralaLogo}
                alt=""
                aria-hidden="true"
                className="portal-footer-logo portal-footer-logo-spacer"
              />

              <div className="portal-office-card">
                <h5><FaMapMarkerAlt /> BRANCH OFFICE - BANGALORE</h5>
                <strong>Rala Infotech India Pvt. Ltd.</strong>
                <p>
                  BHIVE Premium White Field Campus Plot No. 77, JBR Tech Park,
                  6th Rd, Whitefield, Bengaluru, Karnataka - 560066.
                </p>
              </div>
            </div>
          </div>

          <div className="portal-footer-column">
            <h4>CONTACT</h4>
            <p>
              <span className="portal-contact-icon">
                <FaPhoneAlt />
              </span>
              <a href="tel:+916362053546">+91 6362053546</a>
            </p>
            <p>
              <span className="portal-contact-icon">
                <FaEnvelope />
              </span>
              <a href="mailto:hr@ralainfotech.com">hr@ralainfotech.com</a>
            </p>
          </div>

          <div className="portal-footer-column">
            <h4>FOLLOW US</h4>
            <div className="portal-footer-social">
            <a href="https://www.instagram.com/rala_infotech_india_pvt_ltd/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.facebook.com/profile.php?id=100081587340217" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/rala-infotech-india-pvt-ltd/?viewAsMember=true" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.youtube.com/@ralainfotech531" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
            <div className="portal-footer-certifications">
              <img src={startupIndia} alt="Startup India" className="portal-startup-logo" />
              <div className="portal-iso-row">
              <img src={iso9001} alt="ISO 9001" className="portal-iso-logo portal iso-9001"  />
              <img src={iso14001} alt="ISO 14001" className="portal-iso-logo portal iso-14001" />
              </div>
            </div>
          </div>
        </div>

        <p className="portal-footer-copy">
          © {new Date().getFullYear()} Rala Infotech. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;